import { UPDATE_ADMIN_APP_DATA, ADD_SETUP_TO_LIST, ADD_AWARDING_RULE_TO_LIST } from './appData.actions';
import { NavigationMenuOptions } from '../../../Enums';

/** @type {AdminAppData.IAppData} */
const initialState = {
    setups: [],
    hyperfinds: [],
    dataviews: [],
    genericNotificationTemplates: [],
    awardingRules: [],
    isAdminAppDataLoaded: false,
    customDateFormat: [],
    adminPage: NavigationMenuOptions.BidSetups,
    pageName: '',
    notificationCustomTags: [],
};

/**
 * @param {AdminAppData.IAppData} state
 * @param {ShiftBidding.IAction} action
 * */
// eslint-disable-next-line default-param-last
export default function adminAppDataReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_ADMIN_APP_DATA:
            return {
                ...state,
                ...payload,
            };
        case ADD_SETUP_TO_LIST:
            return {
                ...state,
                setups: [
                    ...state.setups,
                    payload,
                ],
            };
        case ADD_AWARDING_RULE_TO_LIST:
            return {
                ...state,
                awardingRules: [
                    ...state.awardingRules,
                    payload,
                ],
            };
        default:
            return state;
    }
}
